import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from './checkbox.component';
import { RadioComponent } from './radio.component';
import { AutoSearchComponent } from './autosearch.component';
import { DatePickerDirective } from '../datepicker/datepicker.directive';
import {ToggleComponent} from './toggle.component';
import { ToggleComponentV1 } from './toggle.componentV1';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule],
    declarations: [CheckboxComponent, RadioComponent, AutoSearchComponent, DatePickerDirective, ToggleComponent, ToggleComponentV1],
    exports: [CheckboxComponent, RadioComponent, AutoSearchComponent, DatePickerDirective, ToggleComponent, ToggleComponentV1]  
})
export class UIModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_extra/ui/ui.module.ts